module.exports = __webpack_public_path__ + "static/img/activity2.18fd726c.png";